/**
 * Slider component type definitions
 */

export enum SliderSize {
  Small = 'sm',
  Default = 'default',
  Large = 'lg',
}

export enum SliderVariant {
  Default = 'default',
  Success = 'success',
  Warning = 'warning',
}
